import template from './rw-button.html';

export default class RwButtonComponent {
  constructor() {
    this.template = template;
    this.transclude = true;
    this.bindings = {
      variant: '@?',
      ariaLabel: '@?',
      tabindex: '<?',
      disabled: '<?',
      action: '&',
      type: '@?',
    };
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-button/rw-button-component.js